export default __webpack_public_path__ + "static/media/all-icon.71c46020.webp";